/**
 * 文件作用：适配器注册器
 * - 采用 provider + taskType 的键格式注册适配器，便于按能力路由
 * - 提供注册、查询、列出功能
 *
 * 使用说明：
 *   registerAdapter('NanoBanana', 'text', nanoBananaAdapter);
 *   const a = getAdapter('NanoBanana', 'text');
 *
 * 本文件使用中文注释以满足项目注释规范
 */
import { GenerationAdapter, TaskType } from './types';

type AdapterKey = string;

const registry = new Map<AdapterKey, GenerationAdapter>();

const buildKey = (provider: string, taskType: TaskType) => {
  return `${provider}:${taskType}`;
};

/**
 * 注册适配器
 * - provider: 提供商名称（例如 'NanoBanana' 或 'VEO'）
 * - taskType: 任务类型（'text'|'video' 等）
 * - adapter: 实现了 GenerationAdapter 的对象
 */
export const registerAdapter = (provider: string, taskType: TaskType, adapter: GenerationAdapter) => {
  const key = buildKey(provider, taskType);
  registry.set(key, adapter);
};

/**
 * 获取适配器
 * - 找不到时返回 undefined，调用方负责处理兜底逻辑（例如报错或写入历史）
 */
export const getAdapter = (provider: string, taskType: TaskType): GenerationAdapter | undefined => {
  const key = buildKey(provider, taskType);
  return registry.get(key);
};

/**
 * 列出已注册适配器的键（用于调试或管理面板）
 */
export const listAdapters = (): { key: string; provider: string; taskType: TaskType }[] => {
  const out: { key: string; provider: string; taskType: TaskType }[] = [];
  for (const key of registry.keys()) {
    const [provider, taskType] = key.split(':');
    out.push({ key, provider, taskType: taskType as TaskType });
  }
  return out;
};